/* eslint-disable no-debugger */
import React from 'react'
import {Elements} from '@recurly/react-recurly'
import {
  Button,
  Icon,
  ParagraphText,
  Checkbox,
  Select,
  Radio,
} from '@thryvlabs/maverick'
import rawCountryStates from 'iso3166-2-db/i18n/en'
import {TaxesPromptContainer} from '../ui-view/payment-information'
import {AutopayTerms} from './autopay-terms'
import {usePaymentAddress} from './keap-partner/payment-information-components/contexts/payment-address-context'
import {usePaymentCheckboxes} from './keap-partner/payment-information-components/contexts/payment-checkboxes-context'
import {COUNTRIES} from './keap-partner/payment-information-components/constants'
// import {usePaymentOrder} from './keap-partner/payment-information-components/hooks/use-payment-order'
import {useDispatch, useSelector} from 'react-redux'
import {nextPaymentStep, setPaymentStep} from '../redux/paymentScreenViewSlice'
import {usePaymentBankAccount} from './keap-partner/payment-information-components/contexts/payment-bank-account-context'
import {useRecurly} from '@recurly/react-recurly'
import {setRecurlyTokenData} from '../redux/recurlySlice'
import {toast} from 'react-toastify'
const ACCOUNT_TYPE_OPTIONS = [
  {label: 'Checking', value: 'checking'},
  {label: 'Savings', value: 'savings'},
]
const AchRecurlyPaymentForm = ({
  showFirstSection,
  showSecondSection,
  nextStep,
  businessAddress,
  country,
  setIsAddressUpdated,
  bizphone,
  isAddressUpdated,
}) => {
  const [selectedCountry, setSelectedCountry] = React.useState(
    COUNTRIES.find(({value}) => value === country),
  )

  const {
    addressInformation,
    isValidAddress,
    updateAddressField,
    resetAddress,
    setFromBusinessAddress,
  } = usePaymentAddress()
  const {checkBoxesValues, setCheckBoxesValues} = usePaymentCheckboxes()
  const {is5Order} = true //usePaymentOrder()
  const {bankAccountInformation, updateBankAccountField, isValidBankAccount} =
    usePaymentBankAccount()
  const [listOfStates, setListOfStates] = React.useState([])
  const formRef = React.useRef()
  const {useBusinessAddressInfo} = checkBoxesValues
  // const {frontendUpdatedTerms} = useFlags()
  const frontendUpdatedTerms = true

  const isAusNZ = ['AU', 'NZ'].includes(country)
  const dispatch = useDispatch()
  const {isMobileViewEnable} = useSelector(state => state.screenView)
  const handleOnchange = ({target: {value, name}}) => {
    console.log('handle on change', name, value)
    updateAddressField(name, value)
  }
  const handleBankAccountChange = ({target: {value, name}}) => {
    console.log({name, value})
    updateBankAccountField(name, value)
  }
  React.useEffect(() => {
    const getStates = () => {
      let stateLabel = ''
      if (['US', 'AU', 'NZ'].includes(selectedCountry.value)) {
        stateLabel = 'State'
      } else if (selectedCountry.value === 'KY') {
        stateLabel = 'City'
      } else if (selectedCountry.value === 'CA') {
        stateLabel = 'Province'
      } else if (selectedCountry.value === 'BB') {
        stateLabel = 'Parish'
      }
      let blankOption = [{name: 'Select ' + stateLabel, value: ''}]
      const states = rawCountryStates[selectedCountry.value].regions
        .map(({iso, name}) => ({
          name,
          value: iso,
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1))
      setListOfStates([...blankOption, ...states])
    }
    if (selectedCountry.value) {
      getStates(selectedCountry.value)

      updateBankAccountField('country', selectedCountry.value)
    }
  }, [selectedCountry])
  React.useEffect(() => {
    if (useBusinessAddressInfo) {
      if (checkBoxesValues.updateBillingAddress) {
        setCheckBoxesValues({...checkBoxesValues, updateBillingAddress: false})
      }
      console.log({businessAddress})
      setFromBusinessAddress(businessAddress)
      updateBankAccountField(
        'accountName',
        `${businessAddress.firstName} ${businessAddress.lastName}`,
      )
    } else {
      resetAddress()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useBusinessAddressInfo, businessAddress, listOfStates])
  const {recurlyTokenDetail} = useSelector(state => state.recurlyTokenData)
  const recurly = useRecurly()

  React.useEffect(() => {
    if (!checkBoxesValues.agreedTerms) return undefined
    if (recurlyTokenDetail) return undefined

    function fetchBankAccountToken(data) {
      recurly.bankAccount.token(data, (err, token) => {
        if (err) {
          dispatch(setPaymentStep(2))
          setCheckBoxesValues({
            ...checkBoxesValues,
            agreedTerms: false,
          })
          console.error(err)
          toast.error(err.message)
          return null
        }
        dispatch(setRecurlyTokenData(token))
      })
    }
    const bankAccountData = {
      name_on_account: bankAccountInformation.accountName,
      routing_number: bankAccountInformation.routingNumber,
      account_number: bankAccountInformation.accountNumber,
      account_number_confirmation:
        bankAccountInformation.accountNumberConfirmation,
      account_type: bankAccountInformation.accountType,
      postal_code: addressInformation.postCode,
      country: bankAccountInformation.country,
      phone: addressInformation.phone,
      address1: addressInformation.address,
      city: addressInformation.city,
      state: addressInformation.state,
      business_name: addressInformation.company,
      business_phone: addressInformation.phone,
    }

    if (isValidBankAccount && isValidAddress) {
      fetchBankAccountToken(bankAccountData)
    }
  }, [recurlyTokenDetail, checkBoxesValues.agreedTerms])
  if (isMobileViewEnable) {
    return (
      <form ref={formRef}>
        <div style={{display: showFirstSection ? 'block' : 'none'}}>
          <div>
            <div>
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Company Name
              </p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="business_name"
                placeholder="Company Name"
                name="company"
                value={addressInformation.company}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Phone Number
              </p>

              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="business_phone"
                placeholder="Phone Number"
                name="phone"
                value={addressInformation.phone}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Account Name
              </p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="name_on_account"
                placeholder="Account Name"
                name="accountName"
                value={bankAccountInformation?.accountName}
                onChange={handleBankAccountChange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>

            <div className="mt-2">
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Routing Number
              </p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="routing_number"
                data-dd-privacy="mask"
                placeholder="Routing Number"
                name="routingNumber"
                value={bankAccountInformation?.routingNumber}
                onChange={handleBankAccountChange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Account Number
              </p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="account_number"
                data-dd-privacy="mask"
                placeholder="Account Number"
                name="accountNumber"
                value={bankAccountInformation?.accountNumber}
                onChange={handleBankAccountChange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="mt-2">
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Confirm Account Number
              </p>
              <input
                className="recurly-element recurly-input w-100"
                style={{height: is5Order ? '35px' : '45px'}}
                data-recurly="account_number_confirmation"
                data-dd-privacy="mask"
                placeholder="Account Number Confirmation"
                name="accountNumberConfirmation"
                onChange={handleBankAccountChange}
                value={bankAccountInformation?.confirmAccountNumber}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>

            <div className="mt-2">
              <p
                className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
                style={{fontSize: '14px', fontWeight: 900}}
              >
                Banking Account Type
              </p>
              <div className="d-flex gap-3 mt-2">
                {ACCOUNT_TYPE_OPTIONS.map(item => (
                  <Radio
                    key={item.label}
                    hasLabel
                    id={item.value}
                    name="accountType"
                    data-recurly="account_type"
                    data-dd-privacy="mask"
                    value={item.value}
                    label={item.label}
                    toggled={bankAccountInformation?.accountType === item.value}
                    handleOnChange={() => {
                      handleBankAccountChange({
                        target: {
                          name: 'accountType',
                          value: item.value,
                        },
                      })
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <input
              type="text"
              placeholder="Postal Code"
              data-recurly="postal_code"
              style={{
                fontSize: '18px',
                width: '96%',
              }}
              onChange={e => {
                handleOnchange(e)
              }}
              className="recurly-element recurly-address"
              name="postalCode"
              value={
                addressInformation.postalCode || addressInformation.postCode
              }
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <Select
            options={COUNTRIES}
            selectLabel="Country"
            width="full"
            className="recurly-element recurly-address mt-3"
            data-recurly="country"
            selectedOption={selectedCountry}
            setSelectedOption={setSelectedCountry}
            disabled={checkBoxesValues.agreedTerms}
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
          <input
            hidden
            readOnly
            type="text"
            placeholder="Country"
            value={selectedCountry.value}
            style={{
              fontSize: '18px',
            }}
            className="recurly-element recurly-address ml-2"
            data-recurly="country"
          />
          <input
            hidden
            readOnly
            type="text"
            placeholder="Phone"
            value={bizphone}
            style={{
              fontSize: '18px',
            }}
            className="recurly-element recurly-address ml-2"
            data-recurly="phone"
          />
          <div className="d-flex justify-content-center mb-4 mt-4">
            <Button
              variant="primary"
              onClick={() => {
                dispatch(nextPaymentStep())
              }}
              className="step__container__button"
              disabled={
                !isValidBankAccount ||
                !addressInformation.postalCode ||
                !addressInformation.phone ||
                !addressInformation.company
              }
            >
              Continue
            </Button>
          </div>
        </div>
        {showSecondSection && (
          <>
            {!isAusNZ && (
              <div
                className="d-flex align-center    info__alert gap-2 px-2"
                style={{
                  background: 'rgb(230, 242, 255)',
                  border: '1px solid rgb(193, 222, 255)',
                  borderRadius: '5px',
                  alignItems: 'center',
                }}
              >
                <Icon type="solid" variant="infoCircle" color="#057aff" />
                <ParagraphText
                  variant="reg"
                  style={{marginTop: '10px', fontSize: '12px'}}
                >
                  The current estimated taxes are based on your business
                  address.
                </ParagraphText>
              </div>
            )}
            <div className="mt-4 mb-2">
              <Checkbox
                hasLabel
                name="useBusinessAddressInfo"
                disabled={checkBoxesValues.agreedTerms}
                checked={checkBoxesValues.useBusinessAddressInfo}
                onChange={e => {
                  setCheckBoxesValues({
                    ...checkBoxesValues,
                    useBusinessAddressInfo: e.target.checked,
                  })
                }}
                label="Same as my business address"
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <div className="d-flex justify-content-between">
              <input
                style={{width: ' 49%'}}
                onChange={handleOnchange}
                className="recurly-element recurly-input"
                data-recurly="first_name"
                placeholder="First Name"
                name="firstName"
                value={addressInformation.firstName}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
              <input
                style={{width: '49%'}}
                className="recurly-element recurly-input"
                data-recurly="last_name"
                placeholder="Last Name"
                name="lastName"
                value={addressInformation.lastName}
                onChange={handleOnchange}
                disabled={checkBoxesValues.agreedTerms}
                title={
                  checkBoxesValues.agreedTerms
                    ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                    : undefined
                }
              />
            </div>
            <input
              type="text"
              className="recurly-element recurly-address"
              data-recurly="address1"
              placeholder="Address"
              style={{
                fontSize: '18px',
              }}
              name="address"
              value={addressInformation.address}
              onChange={handleOnchange}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
            <input
              type="text"
              className="recurly-element recurly-input mt-2.8"
              data-recurly="city"
              placeholder="City"
              style={{
                fontSize: '18px',
              }}
              name="city"
              value={addressInformation.city}
              onChange={handleOnchange}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
            <select
              className="recurly-element recurly-address mt-2.8"
              value={addressInformation?.state}
              onChange={e => {
                handleOnchange({
                  target: {
                    name: 'state',
                    value: e.target.selectedOptions[0].value,
                  },
                })
              }}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            >
              {listOfStates.map(({name, value}) => {
                return (
                  <option key={value} value={value}>
                    {name}
                  </option>
                )
              })}
            </select>
            <input
              hidden
              readOnly
              value={addressInformation?.state}
              type="text"
              className="recurly-element"
              data-recurly="state"
              placeholder="State"
              style={{
                fontSize: '18px',
              }}
            />

            <div className="mt-4 mb-2">
              <Checkbox
                hasLabel
                name="updateBillingAddress"
                disabled={
                  checkBoxesValues.agreedTerms || useBusinessAddressInfo
                }
                checked={checkBoxesValues.updateBillingAddress}
                onChange={e => {
                  setCheckBoxesValues({
                    ...checkBoxesValues,
                    updateBillingAddress: e.target.checked,
                  })
                }}
                label="Update my billing address"
              />
            </div>
            <div className="d-flex justify-content-center mb-4 mt-4">
              <div className="d-flex justify-content-center mb-4 mt-4">
                <Button
                  variant="primary"
                  onClick={() => dispatch(nextPaymentStep())}
                  className="step__container__button"
                  disabled={!isValidAddress}
                >
                  Continue
                </Button>
              </div>
            </div>
          </>
        )}
      </form>
    )
  }
  return (
    <form ref={formRef}>
      <div
        className="d-flex justify-content-between mb-1"
        style={{
          marginTop: is5Order && !isAusNZ ? '10px' : '0',
        }}
      ></div>
      <div>
        <div>
          <p
            className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
            style={{fontSize: '14px', fontWeight: 900}}
          >
            Company Name
          </p>
          <input
            className="recurly-element recurly-input w-100"
            style={{height: is5Order ? '35px' : '45px'}}
            data-recurly="business_name"
            placeholder="Company Name"
            name="company"
            onChange={handleOnchange}
            value={addressInformation.company}
            disabled={checkBoxesValues.agreedTerms}
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
        </div>
        <div className="mt-2">
          <p
            className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
            style={{fontSize: '14px', fontWeight: 900}}
          >
            Phone Number
          </p>

          <input
            className="recurly-element recurly-input w-100"
            style={{height: is5Order ? '35px' : '45px'}}
            data-recurly="business_phone"
            placeholder="Phone Number"
            name="phone"
            onChange={handleOnchange}
            value={addressInformation.phone}
            disabled={checkBoxesValues.agreedTerms}
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
        </div>
        <div className="mt-2">
          <p
            className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
            style={{fontSize: '14px', fontWeight: 900}}
          >
            Account Name
          </p>
          <input
            className="recurly-element recurly-input w-100"
            style={{height: is5Order ? '35px' : '45px'}}
            data-recurly="name_on_account"
            placeholder="Account Name"
            name="accountName"
            onChange={handleBankAccountChange}
            value={addressInformation.accountName}
            disabled={checkBoxesValues.agreedTerms}
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
        </div>

        <div className="mt-2">
          <p
            className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
            style={{fontSize: '14px', fontWeight: 900}}
          >
            Routing Number
          </p>
          <input
            className="recurly-element recurly-input w-100"
            style={{height: is5Order ? '35px' : '45px'}}
            data-recurly="routing_number"
            data-dd-privacy="mask"
            placeholder="Routing Number"
            name="routingNumber"
            onChange={handleBankAccountChange}
            value={bankAccountInformation?.routingNumber}
            disabled={checkBoxesValues.agreedTerms}
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
        </div>
        <div className="d-flex gap-3 mt-2">
          <div style={{width: '50%'}}>
            <p
              className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
              style={{fontSize: '14px', fontWeight: 900}}
            >
              Account Number
            </p>
            <input
              className="recurly-element recurly-input w-100"
              style={{height: is5Order ? '35px' : '45px'}}
              data-recurly="account_number"
              data-dd-privacy="mask"
              placeholder="Account Number"
              name="accountNumber"
              onChange={handleBankAccountChange}
              value={bankAccountInformation?.accountNumber}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
          <div style={{width: '50%'}}>
            <p
              className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
              style={{fontSize: '14px', fontWeight: 900}}
            >
              Confirm Account Number
            </p>
            <input
              className="recurly-element recurly-input w-100"
              style={{height: is5Order ? '35px' : '45px'}}
              data-recurly="account_number_confirmation"
              data-dd-privacy="mask"
              placeholder="Account Number Confirmation"
              name="accountNumberConfirmation"
              onChange={handleBankAccountChange}
              value={bankAccountInformation?.confirmAccountNumber}
              disabled={checkBoxesValues.agreedTerms}
              title={
                checkBoxesValues.agreedTerms
                  ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                  : undefined
              }
            />
          </div>
        </div>
        <div className="mt-2">
          <p
            className="text-p-base font-open-sans font-normal text-thryv-black-600 m-0"
            style={{fontSize: '14px', fontWeight: 900}}
          >
            Banking Account Type
          </p>
          <div className="d-flex gap-3 mt-2">
            {ACCOUNT_TYPE_OPTIONS.map(item => (
              <Radio
                key={item.label}
                hasLabel
                id={item.value}
                name="accountType"
                data-recurly="account_type"
                data-dd-privacy="mask"
                value={item.value}
                label={item.label}
                toggled={bankAccountInformation?.accountType === item.value}
                handleOnChange={() => {
                  console.log(item.value)
                  handleBankAccountChange({
                    target: {
                      name: 'accountType',
                      value: item.value,
                    },
                  })
                }}
              />
            ))}
          </div>
        </div>
      </div>
      {is5Order && frontendUpdatedTerms && <AutopayTerms />}
      {is5Order && (
        <ParagraphText
          variant="lg"
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            margin: frontendUpdatedTerms ? '20px 0 0 0' : '36px 0 0 0',
          }}
        >
          Billing Address
        </ParagraphText>
      )}
      {is5Order && isAddressUpdated && (
        <TaxesPromptContainer>
          <Icon type="regular" variant="infoCircle" color="#057AFF" />
          <ParagraphText variant="reg" className="m-0">
            The current estimated taxes are based on your business address.
          </ParagraphText>
        </TaxesPromptContainer>
      )}
      {is5Order && (
        <div
          className="d-flex align-items-center mt-3 mb-1"
          style={{columnGap: '8px'}}
        >
          <Checkbox
            name="useBusinessAddressInfo"
            disabled={checkBoxesValues.agreedTerms}
            checked={checkBoxesValues.useBusinessAddressInfo}
            onChange={e => {
              setCheckBoxesValues({
                ...checkBoxesValues,
                useBusinessAddressInfo: e.target.checked,
              })
            }}
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
          <ParagraphText variant="reg" style={{margin: '0 0 0.7rem 0'}}>
            Same as my business address
          </ParagraphText>
        </div>
      )}
      {!is5Order && (
        <Select
          options={COUNTRIES}
          selectLabel="Country"
          width="full"
          className="recurly-element recurly-address mt-3"
          data-recurly="country"
          selectedOption={selectedCountry}
          setSelectedOption={setSelectedCountry}
          disabled={checkBoxesValues.agreedTerms}
          title={
            checkBoxesValues.agreedTerms
              ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
              : undefined
          }
        />
      )}
      <input
        hidden
        readOnly
        type="text"
        placeholder="Country"
        value={selectedCountry.value}
        style={{
          fontSize: '18px',
        }}
        className="recurly-element recurly-address ml-2"
        data-recurly="country"
      />
      <input
        type="text"
        className="recurly-element"
        data-recurly="address1"
        placeholder="Street Address"
        style={{
          fontSize: '18px',
          width: '100%',
        }}
        name="address"
        value={addressInformation.address}
        onChange={handleOnchange}
        disabled={checkBoxesValues.agreedTerms}
        title={
          checkBoxesValues.agreedTerms
            ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
            : undefined
        }
      />
      <div className="grid grid-cols-3 gap-2">
        <input
          type="text"
          className="recurly-element"
          data-recurly="city"
          placeholder="City"
          style={{
            fontSize: '18px',
          }}
          name="city"
          value={addressInformation.city}
          onChange={handleOnchange}
          disabled={checkBoxesValues.agreedTerms}
          title={
            checkBoxesValues.agreedTerms
              ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
              : undefined
          }
        />
        <select
          className="recurly-element"
          value={addressInformation?.state}
          style={{height: '36px'}}
          onChange={e => {
            handleOnchange({
              target: {
                name: 'state',
                value: e.target.selectedOptions[0].value,
              },
            })
          }}
          disabled={checkBoxesValues.agreedTerms}
          title={
            checkBoxesValues.agreedTerms
              ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
              : undefined
          }
        >
          {listOfStates.map(({name, value}) => {
            return (
              <option key={value} value={value}>
                {name}
              </option>
            )
          })}
        </select>
        <input
          hidden
          readOnly
          value={addressInformation?.state}
          type="text"
          className="recurly-element"
          data-recurly="state"
          placeholder="State"
        />
        <input
          type="text"
          className="recurly-element"
          data-recurly="postal_code"
          placeholder="Postal Code"
          style={{
            fontSize: '18px',
          }}
          name="postalCode"
          value={addressInformation.postalCode || addressInformation.postCode}
          onChange={handleOnchange}
          disabled={checkBoxesValues.agreedTerms}
          title={
            checkBoxesValues.agreedTerms
              ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
              : undefined
          }
        />
      </div>
      {is5Order && (
        <Select
          options={COUNTRIES}
          selectLabel="Country"
          width="full"
          className="recurly-element recurly-address mt-3"
          data-recurly="country"
          selectedOption={selectedCountry}
          setSelectedOption={setSelectedCountry}
          disabled={checkBoxesValues.agreedTerms}
          title={
            checkBoxesValues.agreedTerms
              ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
              : undefined
          }
        />
      )}
      {!is5Order && (
        <div className="mt-4 mb-2">
          <Checkbox
            hasLabel
            name="useBusinessAddressInfo"
            checked={checkBoxesValues.useBusinessAddressInfo}
            disabled={checkBoxesValues.agreedTerms}
            onChange={e => {
              setCheckBoxesValues({
                ...checkBoxesValues,
                useBusinessAddressInfo: e.currentTarget.checked,
              })
            }}
            label="Same as my business address"
            title={
              checkBoxesValues.agreedTerms
                ? 'To update your payment method or address, please uncheck the Terms & Conditions box above.'
                : undefined
            }
          />
          {frontendUpdatedTerms && <AutopayTerms styles={{marginTop: 0}} />}
        </div>
      )}
    </form>
  )
}

const AchPaymentForm = ({
  nextStep,
  calculateTaxes,
  calculatingTaxes,
  setCalculatingTaxes,
  showFirstSection = false,
  showSecondSection = false,
  checkBoxesValues,
  setCheckBoxesValues,
  setName,
  businessAddress,
  country,
  handleCompleteOrder,
  setIsAddressUpdated,
  bizphone,
  is5Order,
  isAddressUpdated,
  paymentPreview,
}) => {
  return (
    <Elements>
      <AchRecurlyPaymentForm
        saveRecurlyToken={calculateTaxes}
        calculatingTaxes={calculatingTaxes}
        setCalculatingTaxes={setCalculatingTaxes}
        showFirstSection={showFirstSection}
        showSecondSection={showSecondSection}
        nextStep={nextStep}
        checkBoxesValues={checkBoxesValues}
        setCheckBoxesValues={setCheckBoxesValues}
        setName={setName}
        businessAddress={businessAddress}
        country={country}
        handleCompleteOrder={handleCompleteOrder}
        setIsAddressUpdated={setIsAddressUpdated}
        bizphone={bizphone}
        is5Order={is5Order}
        isAddressUpdated={isAddressUpdated}
        paymentPreview={paymentPreview}
      />
    </Elements>
  )
}

export {AchPaymentForm}
